import style from './styles/ButtonLink.scss';
import { Link } from 'react-router-dom';

const ButtonLink = ({ text, to, disabled, showArrow, className }) => {
	const classes = style['button-link'] +
		(showArrow === true ? ` ${style['with-arrow']}` : '') +
		(className ? ` ${className}` : '')
	;
	if (disabled) {
		return (
			<div className={`${classes} ${style.disabled}`}>
				<span className={style.text}>{text}</span>
				{showArrow === true ? <span className={style.arrow} /> : null}
			</div>
		);
	}

	return (
		<Link className={`${classes}`} to={to}>
			<span className={style.text}>{text}</span>
			{showArrow === true ? <span className={style.arrow} /> : null}
		</Link>
	);
};

export default ButtonLink;


// WEBPACK FOOTER //
// ./components/button/ButtonLink.js